import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepData } from '../home-how-does-stay-at-work';

@Component({
  selector: 'app-step-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './step-card.html',
})
export class StepCardComponent {
  @Input() step!: StepData;
  @Input() showConnector: boolean = false;
}
